/**
 * This file holds the actions/mutations types
 * For more information about why this is needed
 * check here https://vuex.vuejs.org/guide/mutations.html#using-constants-for-mutation-types
 */

export const LOAD_LIBRARY_ENPOINTS = "LOAD_LIBRARY_ENPOINTS";
export const SET_ENDPOINTS = "SET_ENDPOINTS";
export const SET_PUBLIC_PATH = "SET_PUBLIC_PATH";
